module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-6 large-centered"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "large-6 columns"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.free_xp),
      expression: "free_xp"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1"
    },
    domProps: {
      "value": (_vm.free_xp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.free_xp = $event.target.value
      }
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [_c('div', {
    staticClass: "note text-left"
  }, [_vm._v("Cette partie permet d'ajouter ou supprimer des Xp pour le joueur")]), _vm._v(" "), _c('div', {
    staticClass: "note text-left"
  }, [_vm._v("Pratique pour gérer les règles cheulous de BB2020")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "large-6 columns"
  }, [_c('h6', [_vm._v("Saisir le nombre de Xp à ajouter")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-429213aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/team-customize-modals/free-xp-customizer.vue
// module id = 740
// module chunks = 0